import { Controller } from "stimulus"

const loadImage = (img, cb) => {
  img.addEventListener("load", cb)
  img.addEventListener("error", function () {
    console.log("Image load error")
  })
  img.src = img.getAttribute("data-original-src")
  if (img.complete && img.naturalWidth !== undefined) {
    cb()
  }
}

export default class HeroController extends Controller {
  static get targets() {
    return ["background", "backgrounds", "letter", "quote", "quotes"]
  }

  connect() {
    this.bgLoadCount = 0
    this.next = 0

    this.loadBackgrounds()
    this.showQuote()
    this.showLetters()
  }

  loadBackgrounds() {
    this.backgroundTargets.forEach((bg) => {
      loadImage(bg, this.backgroundLoaded.bind(this))
    })
  }

  showNextBg() {
    const bg = this.backgroundTargets[this.next]
    bg.classList.add("show")
    setTimeout(() => {
      bg.classList.remove("show")
    }, 13000)
    setTimeout(() => {
      this.next = this.next + 1 == this.backgroundTargets.length ? 0 : this.next + 1
      this.showNextBg()
    }, 10000)
  }

  backgroundLoaded() {
    this.bgLoadCount += 1
    if (this.bgLoadCount == this.backgroundTargets.length) {
      this.showNextBg()
    }
  }

  showQuote() {
    this.randomQuoteIndex = Math.floor(Math.random() * this.quoteTargets.length)
    this.quoteTargets[this.randomQuoteIndex].classList.add("show")
  }

  resizeQuotesWrapper() {
    if (this.randomQuoteIndex) {
      this.quotesTarget.style.height = this.quoteTargets[this.randomQuoteIndex].offsetHeight + "px"
    }
  }

  showLetters() {
    this.letterTargets.forEach((l) => {
      const ds = 2 + Math.random() * 2
      l.setAttribute("data-ds", ds)
      setTimeout(
        (letter) => {
          letter.querySelector("b").classList.add("show")
        },
        Math.random() * 1000,
        l
      )
    })

    const year = new Date().getFullYear().toString()
    Array.from(this.element.querySelectorAll(".letters .year b")).forEach((l, i) => {
      l.textContent = year[i]
    })
  }

  moveLetters() {
    const scrollTop = window.pageYOffset
    this.backgroundsTarget.style.transform = `translateY(${scrollTop / 4}px)`
    this.letterTargets.forEach((l) => {
      const pos = scrollTop / l.getAttribute("data-ds")
      l.style.transform = `translateY(${pos}px)`
      l.style.opacity = 1 - pos / 200
    })
  }
}
